import { Translation } from '../api-types/common';

export function getTranslatedValue(
  translations: Translation[] = [],
  defaultLanguage?: string,
): string {
  const translation =
    translations.find((t) => t.lang === defaultLanguage) ??
    translations.find((t) => t.lang === 'en') ??
    translations[0];
  return translation?.value ?? '';
}
